import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { importMetaEnv } from '~sf/constants';

const IGNORED_ENVS = ['local', 'test'];

export const setupSentry = () => {
  const dsn = importMetaEnv.VITE_SENTRY_DSN;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    enabled: !IGNORED_ENVS.includes(importMetaEnv.VITE_ENV_NAME),
    environment: importMetaEnv.VITE_ENV_NAME,
    release: importMetaEnv.VITE_CODE_VERSION,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: 0.1,

    // Session replays
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,

    beforeSend: filterSentryEvents,
  });
};

const filterSentryEvents: Sentry.BrowserOptions['beforeSend'] = (event, hint) => {
  const error = hint.originalException as Error | undefined;

  if (!error) {
    return event;
  }

  // Ignored noisy errors that aren't actionable:
  const isUPlotError = !!(
    error.stack?.match(/uplot/giu) &&
    (error.message.match(/cannot read properties of undefined/giu) ||
      error.message.match(/undefined is not an object/giu))
  );
  const isDynamicallyImportedModuleFailure = !!error?.message?.match(
    /failed to fetch dynamically imported module/giu,
  );

  if (isUPlotError || isDynamicallyImportedModuleFailure) {
    return null;
  }

  return event;
};
